import { CartDropdown } from "./cart-dropdown";
import { useFirebaseAuth } from "@/hooks/use-firebase-auth";

export default function CartIcon() {
  const { user } = useFirebaseAuth();

  // Authenticated users should always have a visible cart entry point; the
  // dropdown handles the empty state.
  if (user) {
    return <CartDropdown />;
  }

  // No cart for unauthenticated users or empty cart
  return null;
}
